var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappSocials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F77962"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0227 7C10.1692 7 7.04537 10.0992 7.04537 13.9224C7.04537 15.1911 7.38973 16.3797 7.99006 17.4021H7.9898L7 21L10.7277 20.0259C11.709 20.5484 12.8308 20.845 14.0224 20.845C17.8759 20.845 20.9997 17.7458 20.9997 13.9226C20.9997 10.0995 17.8762 7 14.0227 7ZM17.2109 16.7428C16.9887 17.0285 16.3675 17.2817 15.9149 17.2653C15.4623 17.2489 15.3759 17.253 14.3 16.8612C12.8991 16.3408 12.066 15.3552 11.6402 14.8348C10.5357 13.4818 10.4677 12.7675 10.4759 12.3512C10.4841 11.9348 10.62 11.5594 10.9079 11.1715C11.1958 10.7838 11.3647 10.7633 11.8088 10.7552C12.2532 10.747 12.2941 11.0654 12.397 11.3063C12.397 11.3063 12.7602 12.1929 12.8465 12.3706C12.9329 12.5481 12.8403 12.6614 12.7818 12.7716C12.7233 12.8818 12.4671 13.1818 12.3653 13.2859C12.2635 13.39 12.2738 13.5186 12.3478 13.6247C12.4217 13.7308 12.8004 14.3144 13.0512 14.5471C13.5201 15.0287 14.1394 15.3645 14.5681 15.588C14.9323 15.7746 15.0187 15.6491 15.1174 15.5268C15.2161 15.4043 15.5772 14.9676 15.6883 14.833C15.7994 14.6983 16.2438 14.9228 16.7908 15.1923C17.338 15.4616 17.5189 15.5516 17.5437 15.6578C17.5602 16.2782 17.4326 16.4577 17.2104 16.7436L17.2109 16.7428Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappSocials);
export default __webpack_public_path__ + "static/media/whatsapp-socials.d0caca3b142cdf5d5e1a6938f0284999.svg";
export { ForwardRef as ReactComponent };